export default "__VITE_ASSET__DzcarTiU__"